import {ActionTree} from 'vuex';
import axios from 'axios';
import {RootState} from '@/store/types';
import {TemplatesState, CustomTemplateItem} from './types';
import {directDownload} from "@/utils/download-helper";
import {TemplatesFilterParams} from "@/store/sms/templates/types";

export const actions: ActionTree<TemplatesState, RootState> = {
    getCustomTemplates: ({commit, dispatch}, data: TemplatesFilterParams) => {
        return new Promise((resolve, reject) => {
            axios({
                url: '/acapi/custom/templates',
                params: data,
            })
                .then((resp:any) => {
                    commit('setCustomTemplates', resp.data.templates);
                    resolve(resp)
                })
                .catch((err:any) => {
                    reject(err)
                })
        })
    },
    exportCustomTemplates: ({commit, dispatch}, data: TemplatesFilterParams) => {
        return directDownload('/acapi/custom/templates/export', data)
    },
    getCustomMultichannelTemplates: ({commit, dispatch}, data: any) => {
        return new Promise((resolve, reject) => {
            axios({
                url: `/acapi/${data.transport}/templates`,
                params: data.filter
            })
                .then((resp:any) => {
                    commit('setCustomMultichannelTemplates', resp.data.templates);
                    resolve(resp)
                })
                .catch((err:any) => {
                    reject(err)
                })
        })
    },
    getCustomTemplateItem: ({commit, dispatch}, id) => {
        return new Promise((resolve, reject) => {
            axios({
                url: `/acapi/custom/templates/${id}`,
                params: {cache: Math.random()},
            })
                .then((resp:any) => {
                    let smsItem = <CustomTemplateItem>resp.data;
                    smsItem.ttl = smsItem.ttl ? smsItem.ttl / 3600 : null
                    smsItem.id = id;
                    commit('setCustomTemplateItem', smsItem);
                    resolve(smsItem)
                })
                .catch((err:any) => {
                    reject(err)
                })
        })
    },
    saveCustomTemplate: ({commit, dispatch}, data: CustomTemplateItem) => {
        return new Promise((resolve, reject) => {
            data.ttl = data.ttl ? data.ttl * 3600 : null
            data.send_evenly = data.send_evenly ?? 0
            data.save_text = data.save_text ?? 0
            axios({
                method: data.id ? 'put' : 'post',
                url: '/acapi/custom/templates/' +  (data.id ?? ''),
                data: data
            })
                .then((resp:any) => {
                    console.log(resp.data);
                    dispatch('getCustomTemplates');
                    resolve(resp)
                })
                .catch((err:any) => {
                    // errorNotify(err);
                    reject(err)
                })
        })
    },
    deleteCustomTemplate: ({commit, dispatch}, data: CustomTemplateItem) => {
        return new Promise((resolve, reject) => {
            let editId = '';
            if (!data.id) {return}
            editId = data.id.toString();

            axios({
                method: 'delete',
                url: '/acapi/custom/templates/'+editId,
                data: data
            })
                .then((resp:any) => {
                    resolve(resp)
                })
                .catch((err:any) => {
                    reject(err)
                })
        })
    },
};
